/**
 * Pings the sandbox health endpoint to keep the sandbox alive
 */

import { imagineStore } from "@/stores/imagine.store";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

export const useSandboxHealthPing = (): UseQueryResult<boolean, Error> => {
  const previewUrl = imagineStore.use.previewState.previewUrl();
  const isInstrumented = imagineStore.use.sandboxState.instrumented();

  const [, hostWithSandboxId] = previewUrl?.host.split("-") ?? [];
  const [sandboxId] = hostWithSandboxId?.split(".") ?? [];

  return useQuery<boolean, Error>({
    queryKey: ["sandbox-health-ping", sandboxId],
    enabled: Boolean(previewUrl) && isInstrumented,
    refetchInterval: 30000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    retry: 3,
    refetchOnMount: true,
    queryFn: async (): Promise<boolean> => {
      const response = await fetch(
        `${previewUrl?.origin.replace("3000", "3005")}/health`,
      );

      if (!response.ok) {
        throw new Error(`Health check failed: ${response.status}`);
      }

      return true;
    },
  });
};
